// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table[data-v-327ebe1c] {\n  width: 100%;\n  margin-bottom: 12px;\n}\n[data-v-327ebe1c] .giftStyle {\n  background: #f5f7fa94;\n}\n[data-v-327ebe1c] .isErr {\n  color: red;\n}\n[data-v-327ebe1c] .el-table th,\n.el-table tr[data-v-327ebe1c] {\n  background: #e8e8e8 !important;\n}\n[data-v-327ebe1c] .content-scrollbar {\n  overflow-x: hidden;\n  overflow-y: scroll;\n  box-sizing: border-box;\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
